import { createStore, compose, combineReducers, applyMiddleware } from 'redux'

import thunk from 'redux-thunk'

import { authUser } from './users'
import { appData } from './appData'

const reducers = {
  authUser,
  data: appData
}

const reducer = combineReducers(reducers)

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const store = createStore(reducer, composeEnhancer(applyMiddleware(thunk)))

export default store
